import { types } from '../types/types'

const initialState = {
    detail: {
        saved: false,
        hitos: []
    },
    list: [],
    totales: {},
    saved_cloud: false
}

export const projectReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.projectLoadList:
            return {
                ...state,
                list: [...action.payload]
            }

        case types.projectSetNewId:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id: action.payload.id,
                    numero: action.payload.numero
                }
            }

        case types.projectLoadDetail:
            return {
                ...state,
                detail: action.payload
            }


        case types.projectSavedCloud:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    saved: action.payload
                }
            }

        // TASK
        case types.hitoAdd:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    hitos: [...state.detail.hitos, action.payload]
                }
            }

        case types.setAllHitos:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    hitos: action.payload
                }
            }

        // case types.taskAdd:
        //     return {
        //         ...state,
        //         detail: {
        //             ...state.detail,
        //             hitos: action.payload
        //         }
        //     }

        default:
            return state;
    }

}
